import { setupCartStep, resetCartData, updateCartProduct } from 'model/cart';
import { getUser } from 'model/user';

export default store => ({
	path: 'cart',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./component').default;
					cb(null, component);
				},
				'Cart',
			),
		onEnter: ({
			location: {
				query: { status },
			},
		}) => {
			if (status === 'success' || status === 'fail') {
				store.dispatch(setupCartStep(2));
			} else {
				store.dispatch(setupCartStep(0));
				store.dispatch(resetCartData());
				store.dispatch(updateCartProduct());
				const {
					auth: { accessToken },
				} = store.getState();

				if (accessToken !== '') {
					store.dispatch(getUser());
				}
			}
		},
		onChange: () => {
			store.dispatch(setupCartStep(0));
		},
	},
});
